import Vue from 'vue'
import {
  Button,
  Container,
  Aside,
  Popover,
  Tooltip,
  Main,
  Link,
  Input,
  Upload,
  Dialog,
  Loading,
  InfiniteScroll,
  Drawer,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Select,
  Option,
  Row,
  Col,
  Checkbox,
  MessageBox,
  Message,
  Alert,
  Image,
  DatePicker,
  Divider,
  Autocomplete,
  Progress,
  Switch,
  Carousel,
  CarouselItem,
  Radio,
  RadioGroup,
  Skeleton,
  SkeletonItem,
} from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Button)
Vue.use(Container)
Vue.use(Aside)
Vue.use(Popover)
Vue.use(Tooltip)
Vue.use(Main)
Vue.use(Link)
Vue.use(Input)
Vue.use(Upload)
Vue.use(Dialog)
Vue.use(Loading.directive)
Vue.use(InfiniteScroll)
Vue.use(Drawer)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(Row)
Vue.use(Col)
Vue.use(Checkbox)
Vue.use(Alert)
Vue.use(Image)
Vue.use(DatePicker)
Vue.use(Divider)
Vue.use(Autocomplete)
Vue.use(Progress)
Vue.use(Switch)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Skeleton)
Vue.use(SkeletonItem)

Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$message = Message
